import { faCartCircleCheck, faListTree } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { StyledMUIButton } from 'src/components/Button';
import { CheckoutConfirmationProps } from '../Confirmation';

type DesktopCheckoutConfirmationProps = Omit<CheckoutConfirmationProps, 'gtmData'>;

export function DesktopCheckoutConfirmation({
  confirmationNo,
  isOrderPOR,
  confirmationTitle,
  confirmationParagraph1,
  confirmationParagraph2,
}: DesktopCheckoutConfirmationProps) {
  const { push } = useHistory();
  const { t } = useTranslation('orders');
  const context = isOrderPOR ? 'quote' : 'order';

  return (
    <ConfirmationContainer>
      <ConfirmationTitle>{t(confirmationTitle ?? 'confirmation.title', { context })}</ConfirmationTitle>
      <FontAwesomeIcon icon={faCartCircleCheck} size="6x" />
      <ConfirmationBody>
        {t(confirmationParagraph1 ?? 'confirmation.body', { confirmationNo, context })}
      </ConfirmationBody>
      <ConfirmationBody>{t(confirmationParagraph2 ?? 'confirmation.cta')}</ConfirmationBody>
      <PartsCatalogueButton
        data-testid="empty-cart-button"
        startIcon={<FontAwesomeIcon icon={faListTree} size="sm" />}
        onClick={/* istanbul ignore next */ () => push('/product-library')}
      >
        {t('confirmation.productLibraryButton')}
      </PartsCatalogueButton>
    </ConfirmationContainer>
  );
}

const PartsCatalogueButton = styled(StyledMUIButton)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;

const ConfirmationContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[900]};
  margin-top: 6rem;
`;

const ConfirmationTitle = styled(MUITypography)`
  margin-bottom: 7.25rem;
  text-align: center;
`;
ConfirmationTitle.defaultProps = { variant: 'h4' };

const ConfirmationBody = styled(MUITypography)`
  margin-top: 2rem;
  margin-bottom: 1rem;
  text-align: center;
  white-space: pre-line;
`;
ConfirmationBody.defaultProps = { variant: 'body1' };
